var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.191,
    height: 17.191,
    viewBox: "0 0 17.191 17.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(-1070.14 -994.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(1070.49 995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M21.562,9.649l-6.024,6.024a.907.907,0,0,0,1.283,1.283l6.022-6.022v2.014a.825.825,0,0,0,1.649,0V8.824A.825.825,0,0,0,23.667,8H19.543a.825.825,0,0,0,0,1.649Zm2.93,8.246v4.541a1.951,1.951,0,0,1-1.828,2.055H9.828A1.953,1.953,0,0,1,8,22.436V10.055A1.951,1.951,0,0,1,9.828,8H14.6a.825.825,0,0,1,0,1.649H10.119a.513.513,0,0,0-.47.55V22.292a.518.518,0,0,0,.47.55H22.373a.513.513,0,0,0,.47-.55v-4.4a.825.825,0,0,1,1.649,0Z",
    transform: "translate(-8 -8)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.aef44823240c09bfefd313fca2feb56a.svg";
export { ForwardRef as ReactComponent };